var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fam-picker-instruction"},[(!_vm.verifyComplete)?_c('div',{staticClass:"copy"},[_vm._v("完成人脸核验后，可现场扫脸开启互动体验；"),_c('br'),_vm._v("若跳过人脸核验，可现场扫码开启互动体验。")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }